module.exports = __webpack_public_path__ + "img/mobile-33.372b01a0.png";